import { MobileCardDefinition } from '../services/layout';
import { FC } from 'react';

import { Typography, Paper, Container, Theme, CardHeader } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import React from 'react';

import { FormControlProps, useImplicitVisibility } from '../utils';
import { LayoutNodeWrapper } from './LayoutNode';
import { registry } from '../registry';
import { TemplatedText } from './TemplatedText';

export interface CardProps extends FormControlProps<MobileCardDefinition> {
}

const useStyles = makeStyles((theme: Theme) => {

  const { spacing, palette, breakpoints } = theme;

  return createStyles({
    card: {
      flex: 1,
      paddingTop: spacing(2),
      paddingBottom: spacing(2)
    },
    header: {
      // borderBottomRightRadius: '0px',
      // borderBottomLeftRadius: '0px',
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
      borderTopRightRadius: '4px',
      borderTopLeftRadius: '4px',
      color: palette.background.paper,
      backgroundColor: palette.primary.main,
      alignContent: 'center',
      fontWeight: 500,
      height: '28px',
      fontSize: '1.125rem',
      lineHeight: 1.6,
      [breakpoints.up('sm')]: {
        fontSize: '1.25rem',
        height: '32px',
      }
    },
    title: {
      verticalAlign: 'middle',
      lineHeight: '1.2em',
      padding: spacing(2, 0, 1, 4)
    },
    contents: {
      padding: spacing(2, 4, 6, 4),
      display: 'flex',
      flexDirection: 'column'
    },
    child: {
      display: 'flex',
      marginBottom: spacing(1)
    }
  })
});

export const Card: FC<CardProps> = function(props) {
  const { definition, path } = props;
  const styles = useStyles();

  const i = useImplicitVisibility(definition);

  return i ? <Container maxWidth = { 'lg' } className = { styles.card }>
                <Paper>
                  { definition.title && (
                    typeof definition.title === 'string'
                      ? <CardHeader className={styles.header} title={definition.title} titleTypographyProps={{variant:'h6'}}></CardHeader>
                      : <CardHeader className={styles.header} component = { TemplatedText } titleTypographyProps={{variant:'h6'}} { ...definition.title }></CardHeader>
                  )}
                  <div className = { styles.contents }>
                    {
                      definition.children.map((_, t) => {
                        return <div className = { styles.child } key = { t }>
                                  <LayoutNodeWrapper
                                    path = { path.concat('/children/') + t }>
                                  </LayoutNodeWrapper>
                              </div>
                      })
                    }
                  </div>
                </Paper>
              </Container> : null
};

registry.registerComponent('Card', Card);
